import styled from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { BORDER_BOX } from 'common';

const {
  SPACING,
} = Tokens;

const VerticalDividerContainer = styled.div`
  ${BORDER_BOX}
  padding: ${SPACING.SPACING_8} 0.1875rem ${SPACING.SPACING_8} 0.1875rem;
  height: 100%;
  min-height: 100%;
  width: auto;
  box-sizing: border-box;
`;

const VerticalDivider = styled.div`
  height: inherit;
  width: 0.0625rem;
  min-width: 0.0625rem;
  background: ${props => props.$theme.color};
`;

const styles = {
  VerticalDividerContainer,
  VerticalDivider,
};

export default styles;